import { render, staticRenderFns } from "./MailAttachment.vue?vue&type=template&id=3e77aade&scoped=true&"
import script from "./MailAttachment.vue?vue&type=script&lang=js&"
export * from "./MailAttachment.vue?vue&type=script&lang=js&"
import style0 from "./MailAttachment.vue?vue&type=style&index=0&id=3e77aade&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e77aade",
  null
  
)

export default component.exports